import { render, staticRenderFns } from "./BusquedaArticuloComponent.vue?vue&type=template&id=a08b68c2&scoped=true"
import script from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"
export * from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"
import style0 from "./BusquedaArticuloComponent.vue?vue&type=style&index=0&id=a08b68c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08b68c2",
  null
  
)

export default component.exports